import './LastModified.scss'

import React from 'react'
import {Theme} from '../Theme'
import {style} from '../../util/style'

const styles = style('lastmodified')

const allowedChannels = [
	'fullpage',
	'news_detail',
	'project_detail',
	'region_detail',
	'sidebarpage',
	'theme_detail'
]

const LastModified: React.FC<{channel: string; date?: Date}> = ({
	channel,
	date
}) => {
	if (!date || !allowedChannels.includes(channel)) return null

	return (
		<div className={styles()}>
			<Theme.Container>
				Deze pagina werd het laatst gewijzigd op{' '}
				<time dateTime={date.toISOString()}>
					{date.toLocaleDateString('nl-BE', {
						year: 'numeric',
						month: 'long',
						day: 'numeric'
					})}
				</time>
				.
			</Theme.Container>
		</div>
	)
}

export default LastModified
